"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tweener = void 0;
var _performanceNow = _interopRequireDefault(require("performance-now"));
var _raf = _interopRequireDefault(require("raf"));
var _tweenFunctions = _interopRequireDefault(require("tween-functions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createAnimationLoop = function createAnimationLoop(config) {
  var options = config.options,
    callback = config.callback,
    instance = config.instance,
    nextLoop = config.nextLoop;
  var startTime = (0, _performanceNow["default"])();
  var endTime = startTime + options.duration;
  var easingFunction = _tweenFunctions["default"][options.easingFunction || 'easeOutQuad'];
  var endCallback = options.endCallback || function () {};
  var tweenValue = options.startValue;
  return function () {
    var currentTime = (0, _performanceNow["default"])();
    if (currentTime >= endTime) {
      if (instance) {
        instance.currentValue = options.endValue;
        instance.cancel();
      }
      callback(options.endValue);
      return endCallback(options.endValue);
    }
    tweenValue = easingFunction(currentTime - startTime, options.startValue, options.endValue, options.duration, options.springFactor);
    if (instance) {
      instance.currentValue = tweenValue;
    }
    callback(tweenValue);
    nextLoop();
  };
};
var tween = function tween(options, callback, instance) {
  // eslint-disable-next-line prefer-const
  var animationLoop;
  var nextLoop = function nextLoop() {
    if (instance) {
      instance.tween = (0, _raf["default"])(animationLoop);
    } else {
      (0, _raf["default"])(animationLoop);
    }
  };
  animationLoop = createAnimationLoop({
    options: options,
    callback: callback,
    instance: instance,
    nextLoop: nextLoop
  });
  nextLoop();
};
var Tweener = exports.Tweener = function Tweener() {
  this.tween = null;
};
Tweener.prototype.init = function (options, callback) {
  this.tween = tween(options, callback, this);
  this.currentValue = null;
};
Tweener.prototype.cancel = function () {
  _raf["default"].cancel(this.tween);
};
var _default = exports["default"] = tween;